import "core-js/modules/es.array.reverse.js";
var _class, _PolygonParameter;
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, makeObservable } from "mobx";
import isDefined from "../../Core/isDefined";
import FunctionParameter from "./FunctionParameter";
let PolygonParameter = (_class = (_PolygonParameter = class PolygonParameter extends FunctionParameter {
  constructor() {
    super(...arguments);
    _defineProperty(this, "type", "polygon");
    makeObservable(this);
  }
  static formatValueForUrl(value) {
    return JSON.stringify({
      type: "FeatureCollection",
      features: [PolygonParameter.getGeoJsonFeature(value)]
    });
  }
  static getGeoJsonFeature(value) {
    return {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: value
      },
      properties: {}
    };
  }
  get geoJsonFeature() {
    if (isDefined(this.value)) {
      return PolygonParameter.getGeoJsonFeature(this.value);
    }
  }
}, _defineProperty(_PolygonParameter, "type", "polygon"), _PolygonParameter), _applyDecoratedDescriptor(_class.prototype, "geoJsonFeature", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "geoJsonFeature"), _class.prototype), _class);
export { PolygonParameter as default };